var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_7483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.5C7.79115 18.7635 8.14053 18.9731 8.52717 19.1163C8.91381 19.2595 9.32974 19.3333 9.75001 19.3333C10.1703 19.3333 10.5862 19.2595 10.9729 19.1163C11.3595 18.9731 11.7089 18.7635 12 18.5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7133 8.73406V8.04478C14.674 6.44642 14.1369 4.92775 13.2132 3.80272C12.2894 2.67769 11.0496 2.03231 9.75003 2C8.44554 2.0461 7.20477 2.70419 6.28198 3.83942C5.35919 4.97464 4.82425 6.50104 4.78677 8.10583V8.73406C4.78677 11.4817 3 11.9701 3 13.4966C3 14.9009 5.63053 16 9.75003 16C13.8695 16 16.5001 14.9009 16.5001 13.4966C16.5001 11.9701 14.7133 11.4817 14.7133 8.73406Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_7483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.7f37d93c91459d2d6068ed172c0c2fb6.svg";
export { ForwardRef as ReactComponent };